import axios, { AxiosRequestConfig, AxiosError, AxiosResponse, AxiosInstance, AxiosRequestHeaders } from "axios";
import { log } from "@/utils/log";
import { API_URL } from "@/configs/app";
import { i18n } from "@/composables/useLocale";
import apis from './apis';
import useNotifications from "@/composables/useNotifications";
import router from '@/router/index';
import { socket } from '@/composables/useSocket';
import { getApiErrorMessage } from "@/utils/getApiError";

export const api: AxiosInstance = axios.create({
    timeout:  600000,
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + token.value,
    },
});

api.interceptors.request.use(onRequest, onRequestError);
api.interceptors.response.use(onResponse, onResponseError);

export function onRequest(config: any) {
    const token = localStorage.getItem('token');
    const data = (typeof config.data !== 'undefined') ? JSON.parse(JSON.stringify(config.data)) : 'No Data';
    config.headers['X-AUTH-TOKEN'] = token;
    config.headers['X-SOCKET-ID'] = socket.value.id || null;
    config.headers['Accept-Language'] = i18n.locale;
    log('api:onRequest:' + config.url, data);
    return config;
}

export function onRequestError(error: AxiosError) {
    log('api:onRequestError', error);
    return Promise.reject(error);
}

function parseResponseData(data: unknown): Record<string, unknown> | null {
    if (data == null) {
        return null;
    }
    if (typeof data === 'string') {
        try {
            const parsed = JSON.parse(data);
            return typeof parsed === 'object' && parsed !== null ? parsed as Record<string, unknown> : null;
        } catch {
            return null;
        }
    }
    if (typeof data === 'object') {
        return data as Record<string, unknown>;
    }
    return null;
}

export function onResponse(response: AxiosResponse) {
    log('api:onResponse:' + response.config.url, response.data);
    return response;
}

export function onResponseError(error: any) {
    log('api:onResponseError', error);

    try {
        const response = error?.response;
        if (!response) {
            useNotifications.error('Ошибка', 'Ошибка запроса');
            return Promise.reject(error);
        }

        const data = parseResponseData(response.data);
        const apiError = data?.error as { code?: string; msg?: string; message?: string } | undefined;
        const code = apiError?.code;
        const msg = getApiErrorMessage(error, '');

        if (code === 'unauthorized') {
            location.href = '/auth?redirect_to=' + location.pathname;
        } else if (code === 'server_error') {
            router.push('/500');
        } else if (code === 'access_denied') {
            router.push('/403');
        } else if (code === 'not_found') {
            router.push('/500');
        } else if (code === 'not_implemented') {
            error.__apiErrorNotified = true;
            useNotifications.error('Запрос не обработан', msg || 'Ошибка запроса');
        } else if (msg) {
            error.__apiErrorNotified = true;
            useNotifications.error('Ошибка', msg);
        } else if (response.status >= 400) {
            error.__apiErrorNotified = true;
            useNotifications.error('Ошибка', `Ошибка ${response.status}`);
        }
    } catch (handlerError) {
        log('api:onResponseError:handler', handlerError);
        useNotifications.error('Ошибка', 'Ошибка запроса');
    }

    return Promise.reject(error);
}

export default apis;
